const getPosts = async (page, postType, taxonomy, term) => {

    let action = 'load_more_posts'

    const requestBody = {
        action: action,
        nonce: smkHelper.nonce,
        page: page,
        post_type: postType,
    }

    try {
        const response = await fetch(smkHelper.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'X-WP-Nonce': smkHelper.nonce
            },
            body: new URLSearchParams(requestBody)
        });

        return response;

    } catch (error) {
        console.error('Error fetching posts:', error);
        throw error; // Re-throw the error to handle it further up the chain
    }
};

export {getPosts}
